import { AsyncState } from '@c42/constants';
import { StsEmployeeInfo } from '@c42/jwt/dist/constants';
import React from 'react';
import { useHistory } from 'react-router';
import { LOGIN_INDEX } from '../../constants/routes';
import c42Jwt from '../../constants/c42Jwt';

type Response = {
  employeeInfo?: StsEmployeeInfo;
  loadingState: AsyncState;
};

export const useEmployeeInfo = (): Response => {
  const [employeeInfo, setEmployeeInfo] = React.useState<StsEmployeeInfo>();
  const [loadingState, setLoadingState] = React.useState<AsyncState>(AsyncState.NOT_STARTED);

  const history = useHistory();

  const loadEmployeeInfo = async () => {
    try {
      setLoadingState(AsyncState.LOADING);
      const employeeInfo = await c42Jwt.getEmployeeInfo();
      setEmployeeInfo(employeeInfo);
      setLoadingState(AsyncState.DONE);
    } catch (e) {
      if (e?.status === 401 || e?.status === 403) {
        history.push(LOGIN_INDEX);
      } else {
        setLoadingState(AsyncState.ERROR);
      }
    }
  };

  React.useEffect(() => {
    loadEmployeeInfo();
  }, []);

  return {
    employeeInfo,
    loadingState,
  };
};
